import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';

export const OrgDashboardViewInternshipPageContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "orgDashboard/ViewInternshipPageContainer" */
      './OrgDashboardViewInternshipPageContainer.dynamic'
    ),
});
